<thr-loading [show]="loader.isLoading()"></thr-loading>
<thr-header-onboarding [showBack]="showBack" (back)="onBack()" *ngIf="!isClientPortal"></thr-header-onboarding>
<thr-header-onboarding-client-portal
    [user]="user"
    [showBack]="showBack"
    (back)="onBack()"
    *ngIf="isClientPortal"
></thr-header-onboarding-client-portal>

<router-outlet></router-outlet>
